// Packages
import { Fragment, useCallback, useEffect, useState } from "react"
import queryString from "query-string"
import PropTypes from "prop-types"
import classNames from "classnames"
import MediaQuery from "react-responsive"
// import { Field } from 'redux-form';
//import { CSSTransition } from "react-transition-group"
import { TransitionGroup, CSSTransition } from "react-transition-group"

// Utils
import isMobile from "components/Stacker/utils/device-check"

// Components
// import ClearFilter from 'components/search/ClearFilter/ClearFilter';
import Overlay from "components/Stacker/components/Overlay/Overlay"

// Configs
import BreakPointConfig from "components/Stacker/constants/breakpoints"
import SPC from "components/Stacker/config/SearchPageConfig"
import Events from "components/Stacker/constants/events"

// Actions
import {
  toogleFilterCategory,
  expandFilterCategory,
} from "components/Stacker/actions/SearchActions"

// Styles
import "./FilterMainCategory.scss"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"

function findQueryValue({ code, filterItemCode, searchValues }) {
  if (
    searchValues &&
    searchValues[code] &&
    searchValues[code].findIndex((i) => i === `"${filterItemCode}"`) >= 0
  ) {
    return true
  }
  return false
}

function FilterMainCategory({
  filterCategory,
  isExpanded,
  shouldShowOverlay = true,
  index,
  collapsedFilterCategories,
  handleFilterChange,
}) {
  const dispatch = useDispatch()
  const { LL } = useI18nContext()
  //const searchValues = useSelector((state) => state.search.filters)
  const selectedFilterItems = useSelector(
    (state) => state.search.filters.selectedFilterItems
  )

  // useEffect(() => {
  //   handleNativeToogle()
  // })
  const getSubCategories = () => {
    const { code, values, rangeFilter, category, decimalFilter } =
      filterCategory
    let subFilters = values

    // here the change will happen for the category name
    const isShowAllFilterOption =
      collapsedFilterCategories[code] && category === "true" // If not expanded yet

    if (isShowAllFilterOption) {
      let filterDisplayCount = SPC.FILTER_DISPLAY_COUNT_DESKTOP
      if (isMobile()) {
        filterDisplayCount = SPC.FILTER_DISPLAY_COUNT_MOBILE
      }
      subFilters = subFilters.slice(0, filterDisplayCount)
    }

    const filterMenuDirectionReverse =
      index > 3
        ? "filter-dropdown-menu filter-dropdown-menu--left"
        : "filter-dropdown-menu filter-dropdown-menu--right"

    if (isExpanded && subFilters.length > 0) {
      return (
        <div
          className={filterMenuDirectionReverse}
          aria-labelledby="dropdownMenuButton"
          aria-expanded={isExpanded}
        >
          {subFilters.map((filterItem) => {
            const {
              name: filterItemName,
              imageUrl,
              count,
              code: filterItemCode,
            } = filterItem
            if (filterItemName) {
              let selectedQuery = `${code}:"${filterItemCode}"`

              const filterName = filterItemName.toLowerCase()

              let dataQuery = selectedQuery

              if (rangeFilter) {
                selectedQuery = `${code}:"${filterItemName}"`
                dataQuery = `${code}:[${filterItemCode}]`
              }

              // redux form is having some issue with the decimal as part of string thus replacing it with '-'
              // but when the query goes to the server , it will be with the '.'

              if (decimalFilter && filterItemCode.indexOf(".") > -1) {
                selectedQuery = `${code}:"${filterItemCode.replace(
                  /\./g,
                  "-"
                )}"`
              }

              const queryValue = findQueryValue({
                code,
                filterItemCode,
                searchValues: selectedFilterItems,
              })

              return (
                <div className="filter-input" key={selectedQuery}>
                  <input
                    type="checkbox"
                    name={selectedQuery}
                    id={filterItemName}
                    data-filter-query={dataQuery}
                    className="sr-only"
                    checked={queryValue}
                    // onChange={(e) => {
                    //   /* do nothing */
                    // }}
                    onChange={(e) => {
                      handleFilterUpdate({
                        target: { dataset: { filterQuery: dataQuery } },
                      })
                      //props.formChange(selectedQuery, !queryValue)
                    }}
                  />
                  <label className="filter-label" htmlFor={filterItemName}>
                    <span />{" "}
                    {imageUrl && (
                      <span className="filter-img">
                        <img alt={filterItemName} src={imageUrl} />
                      </span>
                    )}
                    <span className="filter-text">
                      <abbr title={`${filterName}`}>{`${filterName}  `}</abbr>
                    </span>
                    <span>{`(${count})`}</span>
                  </label>
                </div>
              )
            }
            return null
          })}

          {isShowAllFilterOption && (
            <div className="see-all-filter-btn-wrapper text-center">
              <button
                data-filter-category-code={code}
                className="c-btn see-all-filter-btn"
                type="button"
                onClick={handleSeeAllCollections}
                onTouchTap={handleSeeAllCollections}
              >
                {LL.search.seeAllCollectionsText()}
              </button>
            </div>
          )}
        </div>
      )
    }
    return false
  }

  const handleSeeAllCollections = (e) => {
    const { filterCategoryCode } = e.target.dataset
    dispatch(expandFilterCategory(filterCategoryCode))
  }

  // const nativeFilterHandler = (e) => {
  //   e.preventDefault()
  //   const {
  //     filterCategory: { name },
  //   } = props
  //   if (e.type === Events.ON_MOUSE_ENTER) {
  //     dispatch(toogleFilterCategory(name, true))
  //   } else if (e.type === Events.ON_MOUSE_LEAVE) {
  //     dispatch(toogleFilterCategory(name, false))
  //   }
  // }

  // Handle Hide/Show of Filter Categories
  const handleToogle = useCallback(
    (e) => {
      e.preventDefault()
      const { name } = filterCategory
      if (e.type === Events.ON_MOUSE_ENTER) {
        dispatch(toogleFilterCategory(name, true))
      } else if (e.type === Events.ON_MOUSE_LEAVE) {
        dispatch(toogleFilterCategory(name, false))
      } else if (e.type === Events.ON_CLICK || e.type === Events.ON_TOUCH_END) {
        dispatch(toogleFilterCategory(name))
      }
    },
    [dispatch, filterCategory]
  )

  //const handleNativeToogle = () => {}

  const handleFilterUpdate = useCallback(
    (e) => {
      handleFilterChange(e)
    },
    [handleFilterChange]
  )

  const { code, values, name, category } = filterCategory

  const selectedValue = values.filter((item) => {
    return item.selected === "true" || item.selected === true
  })

  const isShowAllFilterOption =
    collapsedFilterCategories[code] && category === "true"
  const showOverlay =
    shouldShowOverlay && isExpanded && window.innerWidth > 1023

  return (
    <Fragment>
      <div
        className={classNames("FilterMainCategory search-filter-item", {
          expanded: isExpanded,
          showAllFilters: isShowAllFilterOption,
        })}
      >
        <button
          className="btn filter-btn text-black"
          type="button"
          aria-haspopup="true"
          onClick={handleToogle}
        >
          {name}
          <span className="filter-count-section">
            <MediaQuery query={BreakPointConfig.IS_MOBILE}>
              {selectedValue.length > 0 && (
                <span className="subcategory-count">
                  ({selectedValue.length}) Selected{" "}
                </span>
              )}
            </MediaQuery>
            <MediaQuery query={BreakPointConfig.IS_DESKTOP}>
              {selectedValue.length > 0 && (
                <span className="subcategory-count">
                  ({selectedValue.length}){" "}
                </span>
              )}
            </MediaQuery>
            <span className="caret" />
          </span>
        </button>
        {getSubCategories()}
      </div>
      {/* <CSSTransition timeout={50} classNames="fadingIn">
        {showOverlay && <Overlay />}
      </CSSTransition> */}
      {showOverlay && (
        <TransitionGroup>
          <CSSTransition
            appear
            timeout={{ enter: 50, leave: 50 }}
            classNames="fadingIn"
          >
            <Overlay />
          </CSSTransition>
        </TransitionGroup>
      )}
    </Fragment>
  )
}

FilterMainCategory.propTypes = {
  // selectedFilterItems: PropTypes.object.isRequired,
  filterCategory: PropTypes.object.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  shouldShowOverlay: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  collapsedFilterCategories: PropTypes.object.isRequired,
  handleFilterChange: PropTypes.func.isRequired,
  //formChange: PropTypes.func,
}

export default FilterMainCategory
